import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './what-is-edm/HeroSection';
import { HistorySection } from './what-is-edm/HistorySection';
import { WhatIsEDMSection } from './what-is-edm/WhatIsEDMSection';
import { TypesOfEDMSection } from './what-is-edm/TypesOfEDMSection';
import { BottomLinksSection } from './what-is-edm/BottomLinksSection';
export function WhatIsEDMPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-4390">
      <SeoBar data-id="element-4391" />
      <Header data-id="element-4392" />
      <main className="flex-grow" data-id="element-4393">
        <div className="w-full bg-gray-50 pb-20" data-id="element-4394">
          <HeroSection data-id="element-4395" />
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-4396">
            <HistorySection data-id="element-4397" />
            <WhatIsEDMSection data-id="element-4398" />
            <TypesOfEDMSection data-id="element-4399" />
            <BottomLinksSection data-id="element-4400" />
          </div>
        </div>
      </main>
      <Footer data-id="element-4401" />
    </div>;
}